// extracted by mini-css-extract-plugin
module.exports = {"l1udqb06":"l1udqb06"};